import WebglManager from "@/glxp/webglManager"
import TensorManager from "@/tensor/tensorManager"
import WebsocketManager from '@/js/websocketManager.js'
import DebugController from '@/glxp/debug/debugController'
import GameAI from '@/js/gameAI.js'
import Emitter from 'event-emitter'
import { TweenMax } from "gsap/gsap-core"
import Timer from '@/glxp/utils/timer'


const DELAY_UNTIL_AI = 7


class GameManager {
    constructor(vue) {

        this.vue = vue
        this.currentRound = 0
        this.glxp = WebglManager.getScene("main")

        this.haveATeamMate = false
        this.tutoSign = "none"
        this.ai = null
        this.inGame = false
        this.buttonMode = false
        this.misSign = 0
        this.tutoEnded = false
        this.name = ""

        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)
        this.off = this._emitter.off.bind(this._emitter)

        WebsocketManager.setGameManager(this)
    }

    initEvents() {

        if (this.tensorListener) {
            TensorManager.off("signFound", this.tensorListener)
        }
        TensorManager.on("signFound", this.tensorListener = (sign) => {
          if (sign !== 'none') {
            this.vue.currentSign = sign
          }
        })
        if (this.webSocketListener) {
            WebsocketManager.off("tracking", this.webSocketListener)
        }
        WebsocketManager.on("tracking", this.webSocketListener = (sign) => {
            this.vue.currentSignOpponent = sign
        })

        if (this.webSocketResultsListener) {
            WebsocketManager.off("round-result", this.webSocketResultsListener)
        }
        WebsocketManager.on("round-result", this.webSocketResultsListener = (data) => {
            this.onResult(data)
        })


        WebsocketManager.on("leave", () => {
            if (this.inGame == true) {
                this.endCombat()
                this.vue.buttonMode = false
                this.vue.setMove('none')
                this.glxp.setHandTarget("idle", 1)
                this.glxp.setHandTarget("idle")
                TensorManager.desactivate()
                TensorManager.hideFeedBack()
                TweenMax.delayedCall(1, () => {
                    this.vue.showFinalScore(true)
                })
            }
        })


    }

    startTuto() {
        if(!this.vue.skipCam) this.vue.hideButtonMode = false
        this.vue.audio.setRound(0)
        this.vue.$refs.tutoTitle.classList.add('show')
        setTimeout(() => {
            this.vue.$refs.tutoTitle.classList.add('leave')
        }, 2000)
        this.glxp.activateTrackingAnimations()
        if(!this.buttonMode) TensorManager.activate()

        if(!this.vue.skipCam) {
            setTimeout(() => {
                this.vue.promptMessage("Raise your hand to join us")
                this.vue.showTuto = true
                
                TweenMax.delayedCall(1, () => {
                    TensorManager.showFeedBack()
                })
              
                TensorManager.on("signFound", this.listenerSignTuto = (sign) => {
                    this.tutoSign = sign
                })

                TensorManager.resetTracking()
                TensorManager.on("firstTracked", () => {

                    TweenMax.delayedCall(.2, () => {
                        this.glxp.animationManager.showHandRig(0)
                        this.vue.audio.play('handAppear')
                    })
                    TweenMax.delayedCall(2, () => {
                        this.vue.promptMessage("")
                        this.nextStepTuto()
                        this.vue.canSkipIntro = true
                    })
                })
            }, 2500)
        } else {
            TweenMax.delayedCall(.2, () => {
                this.glxp.animationManager.showHandRig(0)
                this.vue.audio.play('handAppear')
            })
            TweenMax.delayedCall(2, () => {
                this.vue.promptMessage("")
                this.nextStepTuto()
                this.vue.canSkipIntro = true
            })
        }

    }

    tutoWatch (sign, target) {
        if( sign === target ) {
            TweenMax.killTweensOf(this.tutoButton)
            this.activateWatchTutoSign(target, () => {
                this.tutoButton = TweenMax.delayedCall(10, () => {
                    if(!this.vue.buttonMode){
                        this.vue.askButton = true
                    }
                })
                TweenMax.delayedCall(1, () => {
                    this.nextStepTuto()
                })
                // this.vue.$refs[`tuto-step-picto-${target}`].classList.add("validated")
            })

        }
    }
    nextStepTuto() {
        this.vue.setMove('none')
        TensorManager.check.lastSign = 'none'
        this.vue.tutoStep++
        if (this.vue.showTuto == false) { return }
        this.vue.askButton = false
        this.tutoButton = TweenMax.delayedCall(15, () => {
            if(!this.vue.buttonMode){
                this.vue.askButton = true
            }
        })

        if (this.vue.tutoStep == 1) {
            TweenMax.delayedCall(1, () => {
                this.vue.$refs["tuto-step-picto-rock"].classList.remove("disable")
            })
            this.vue.$refs["tuto-step-picto-paper"].classList.add("disable")
            this.vue.$refs["tuto-step-picto-scisors"].classList.add("disable")

            this.vue.$refs.rockButton.classList.remove('disabled')
            this.vue.$refs.paperButton.classList.add('disabled')
            this.vue.$refs.scissorsButton.classList.add('disabled')

                this.buttonMode ? this.vue.promptMessage("Click on rock") : this.vue.promptMessage("Make a rock")


            TensorManager.on("signFound", this.tutowatchSetp = (sign) => {
                this.tutoWatch(sign, 'rock')
            })
        } else if (this.vue.tutoStep == 2) {
            this.vue.$refs["tuto-step-picto-rock"].classList.add("disable")
            this.vue.$refs["tuto-step-picto-scisors"].classList.add("disable")

            this.vue.$refs.rockButton.classList.add('disabled')
            this.vue.$refs.paperButton.classList.remove('disabled')
            this.vue.$refs.scissorsButton.classList.add('disabled')

            TweenMax.delayedCall(1, () => {
                this.vue.$refs["tuto-step-picto-paper"].classList.remove("disable")
            })

            this.buttonMode ? this.vue.promptMessage("Click on paper") : this.vue.promptMessage("Make a paper")
      
            TensorManager.on("signFound", this.tutowatchSetp = (sign) => {
                this.tutoWatch(sign, 'paper')
            })
        } else if (this.vue.tutoStep == 3) {
            this.vue.$refs["tuto-step-picto-rock"].classList.add("disable")
            this.vue.$refs["tuto-step-picto-paper"].classList.add("disable")

            this.vue.$refs.rockButton.classList.add('disabled')
            this.vue.$refs.paperButton.classList.add('disabled')
            this.vue.$refs.scissorsButton.classList.remove('disabled')

            TweenMax.delayedCall(1, () => {
                this.vue.$refs["tuto-step-picto-scisors"].classList.remove("disable")
                // console.log(this.vue.$refs["tuto-step-picto-scisors"])
            })
            this.buttonMode ? this.vue.promptMessage("Click on scissors") : this.vue.promptMessage("Make a scissors")
 
            TensorManager.on("signFound", this.tutowatchSetp = (sign) => {
                this.tutoWatch(sign, 'scissors')
            })

        } else if (this.vue.tutoStep == 4) {
            TweenMax.delayedCall(2, () => {
                TensorManager.desactivate()
                this.vue.setMove('none')
                this.endTuto()
                if(this.buttonMode) this.vue.hideButtonMode = true
            this.vue.$refs.rockButton.classList.remove('disabled')
            this.vue.$refs.paperButton.classList.remove('disabled')
            this.vue.$refs.scissorsButton.classList.remove('disabled')
            })
        }

    }

    tutoButton() {

    }


    activateWatchTutoSign(s, onSuccess) {
        if (this.vue.showTuto == false) { return }
        Timer.start(3.8)
        this.vue.audio.play('spinner')

        TweenMax.delayedCall(3, () => {
            this.vue.audio.stop('spinner')
            
            if (this.vue.showTuto == false) { return }
            if (this.tutoSign == s) {
                this.vue.audio.play('roundWin')
                TweenMax.delayedCall(0.5, () => {
                    this.glxp.animationManager.tutoSuccess()
                })
                // this.vue.promptMessage('')
               
                switch (s) {
                    case "rock":
                        this.vue.promptMessage("Great!")
                        break;
                    case "paper":
                        this.vue.promptMessage("Well done!")
                        break;
                    case "scissors":
                        this.vue.promptMessage("You've got it!")
                        break;

                    default:
                        this.vue.promptMessage("Good job!")
                        break;
                }

                setTimeout(() => {
                    // this.vue.promptMessage("")
                    Timer.reset()
                    document.querySelector('.progress-circle').classList.remove('active')

                    this.vue.$refs["tuto-step-picto-rock"].classList.add("disable")
                    this.vue.$refs["tuto-step-picto-paper"].classList.add("disable")
                    this.vue.$refs["tuto-step-picto-scisors"].classList.add("disable")
                }, 2000)
                TweenMax.delayedCall(1, () => {
                    onSuccess()
                    if(this.tutowatchSetp){
                        TensorManager.off('signFound', this.tutowatchSetp)
                    }
                })
            } else {
                Timer.back()
                TensorManager.check.last = 'none'
                // this.vue.promptMessage("Wrong sign... Try again to do a " + s, 'tutoMessage')
                // TweenMax.delayedCall(1.5, () => {
                //     this.activateWatchTutoSign(s, () => {
                //         onSuccess()
                //     })
                // })
            }
        })

    }

    endTuto() {
        if(this.buttonMode) this.vue.hideButton = true
        this.tutoEnded = true;
        // console.log('ENDTUTO')
        Timer.reset()
        if (this.listenerSignTuto) {
            TensorManager.off("signFound", this.listenerSignTuto)
        }


        this.glxp.desactivateTrackingAnimations()
        this.glxp.setHandTarget("idle")
        this.vue.showTuto = false
        this.vue.canSkipIntro = false

        TensorManager.desactivate()
        TweenMax.delayedCall(0.5, () => {
            this.vue.$refs["tuto-step-picto-rock"].classList.add("disable")
            this.vue.$refs["tuto-step-picto-paper"].classList.add("disable")
            this.vue.$refs["tuto-step-picto-scisors"].classList.add("disable")
            this.vue.promptMessage("")
            TensorManager.hideFeedBack()
        })

        TweenMax.delayedCall(2, () => {
            this.vue.promptMessage("We’re looking for a challenger")

            this.vue.isLoading = true
            this.glxp.animationManager.moveHandToFightPosition(0)
        })


        TweenMax.delayedCall(4, () => {
            this.waitForTeamMate()
            if (this.vue.$refs["intro"].nickname.length > 0) {
                WebsocketManager.connect(this.vue.$refs["intro"].nickname)
                this.name = this.vue.$refs["intro"].nickname
            } else {
                this.name = "dev-" + Date.now()
                WebsocketManager.connect(this.name)
            }
        })

    }

    waitForTeamMate() {

        // To kill on restart
        let roomListener
        this.haveATeamMate = false

        let teamMateTimemout = setTimeout(() => {
            if (this.haveATeamMate == false) {
                this.startAI()
            }
        }, DELAY_UNTIL_AI * 1000);

        WebsocketManager.on("roomcomplete", roomListener = (infos) => {
            this.vue.promptMessage("")
            this.vue.isLoading = false
            this.inGame = true
            clearTimeout(teamMateTimemout)
            this.vue.oponentName = infos.username
            this.vue.showOponentName = true
            this.haveATeamMate = true
            this.glxp.animationManager.showPlateform()

            this.glxp.handsRigs[1].mesh.setColor("Hand_Green")
            this.glxp.animationManager.showHandRig(1)
            this.vue.audio.play('handAppear')
            this.glxp.animationManager.moveHandToFightPosition(1)
            WebsocketManager.off("roomcomplete", roomListener)

            TweenMax.delayedCall(2, () => {
                this.vue.promptMessage(`Meet ${this.vue.oponentName}`)

                TweenMax.delayedCall(1.7, () => {
                    this.glxp.animationManager.sayHi(0)
                    this.glxp.animationManager.sayHi(1)
                })
            })
            TweenMax.delayedCall(4, () => {
                this.vue.promptMessage("Ready?")
            })
            TweenMax.delayedCall(6, () => {
            })
            TweenMax.delayedCall(7, () => {
                this.vue.promptMessage("")
                this.startCombat()
            })
        })

    }

    startCombat() {
        if(this.buttonMode) this.vue.hideButton = false
        this.vue.hideButtonMode = false
        if (this.listenerSign) {
            TensorManager.off("signFound", this.listenerSign)
        }
        this.startRound(1)
        this.vue.audio.play('gameStart')
        this.vue.audio.setRound(1)
        TweenMax.delayedCall(10, () => {this.vue.audio.play('plane')})
        this.vue.currentSign = 'none'
        if(!this.buttonMode) {
            TensorManager.check.lastSign = 'none'
            TensorManager.activate()
            TensorManager.showFeedBack()
        }
    }

    endCombat() {
        if(this.buttonMode) this.vue.hideButton = true
        this.vue.hideButtonMode = true

        TweenMax.delayedCall(2, () => {
            this.glxp.setHandTarget("idle", 1)
            this.glxp.setHandTarget("idle")
        })
      
        // this.vue.buttonMode = false
        this.vue.setMove('none')
        TensorManager.desactivate()
        TensorManager.hideFeedBack()
        this.vue.gameEnd = true
        this.inGame = false

        if (this.ai) {
            this.ai.kill()
            this.ai.off("tracking", this.webSocketListener)
            this.ai = null
        } else {
            WebsocketManager.off("tracking", this.webSocketListener)
        }


    }

    startRound(id) {
        TensorManager.check.lastSign = 'none'
        this.glxp.goToStage(id > 3 ? 3 : id)
        this.glxp.setHandTarget("idle", 1)
        this.glxp.setHandTarget("idle")
        this.vue.currentRound = id
        this.currentRound = id

        this.vue.$refs.rockButton.classList.add('disabled')
        this.vue.$refs.paperButton.classList.add('disabled')
        this.vue.$refs.scissorsButton.classList.add('disabled')


        // this.vue.promptMessage("Round " + id)

        // Reset Results for WebSocket player
        // this.results = { me: undefined, opponent: undefined, fired: false }
        // this.vue.currentSign = "none"

        this.results = { me: this.vue.currentSign, opponent: undefined, fired: false }
        // this.vue.currentSign = "none"

        this.vue.currentSignOpponent = "none"
        this.vue.setMove('none')

        if (this.inGame == false) { return }


        TweenMax.delayedCall(1, () => {
            if(id < 3){
                this.vue.promptMessage(`Round ${id}`)
            } else {
                this.vue.promptMessage(`Final Round!`)
            }
            TweenMax.delayedCall(0.5, () => {
                this.vue.promptMessage('Rock, paper or scissors?', 'roundSubtitle')
            })
        })
        TweenMax.delayedCall(5, () => {
            this.vue.promptMessage('')
            this.vue.promptMessage('', 'roundSubtitle')
            this.vue.$refs.rockButton.classList.remove('disabled')
            this.vue.$refs.paperButton.classList.remove('disabled')
            this.vue.$refs.scissorsButton.classList.remove('disabled')
            if(!this.buttonMode) {
                TensorManager.activate()
                TensorManager.showFeedBack()
            }
        })

        TweenMax.delayedCall(7, () => {
            if (this.inGame == false) { return }
            this.vue.beforePlay = true
            // Delayed Call for result
            TweenMax.delayedCall(4, () => {
                if (this.inGame == false) { return }
                this.results.me = this.vue.currentSign
                if (this.ai == null) {
                    WebsocketManager.sendRoundResult({ name: this.name, result: this.vue.currentSign, round: this.currentRound })
                    if (this.results.opponent !== undefined) {
                        this.vue.currentSignOpponent = this.results.opponent
                        this.endRound(this.currentRound)
                    }
                } else {
                    this.results.opponent = this.vue.currentSignOpponent
                    this.endRound(id)
                }
            })
            // Start Timer
            // Timer.start(4)

            TweenMax.delayedCall(1, () => {
                if (this.inGame == false) { return }
                this.glxp.animationManager.playShiFuMiAnimation()
                this.vue.$refs["countdowm"].start()
            })

            this.vue.$refs["countdowm"].reset()

        })

    }

    onResult(data) {
        if (this.inGame == false) { return }
        // if (data.round !== this.currentRound) { return }

        if (this.results.fired == false && data[this.vue.oponentName]) {
          this.results.fired = true
          this.results.me = data[this.vue.nickname]
          this.results.opponent = data[this.vue.oponentName]
          this.vue.currentSignOpponent = this.results.opponent
          this.endRound(this.currentRound)
        }

        // if (data.name == this.vue.oponentName) {
        //     this.results.opponent = data.result
        // }
        // if (this.results.me !== undefined && this.results.fired == false) {
        //     this.results.fired = true
        //     this.vue.currentSignOpponent = this.results.opponent
        //     this.endRound(this.currentRound)
        // }
    }


    endRound(id) {
        if (this.inGame == false) { return }
        let status = this.checkSign()
        this.glxp.setHandTarget(this.vue.currentSign)
        this.glxp.setHandTarget(this.vue.currentSignOpponent, 1)
        // console.log(this.vue.currentSign, this.vue.currentSignOpponent)
        this.vue.getPos()
        TweenMax.delayedCall(0.3, () => {
            if (this.inGame == false) { return }
            if (status == "tie") {
               
                this.vue.audio.play('reveal')
                this.vue.currentSign = 'none'
                this.vue.setMove('none')

                TweenMax.delayedCall(1, () => {
                    this.startRound(id)
                })
                if(!this.buttonMode) {
                  TensorManager.check.lastSign = 'none'
                }

            } else {
                this.vue.showSigns = true
                this.vue.activeSignOpp = this.vue.currentSignOpponent
                this.vue.activeSignMe = this.vue.currentSign
                setTimeout(() => {
                    this.vue.showSigns = false
                    TweenMax.delayedCall(0.5, () => {
                        this.vue.result = ''
                    })
                }, 2500)
                if (status == "win") {
                    this.vue.result = 'win'

                    this.vue.scores.me++
                    this.vue.displayedScore.me.push(1)
                    this.vue.displayedScore.opponent.push(0)
                } else {
                    this.vue.result = 'lose'

                    this.vue.scores.opponent++
                    this.vue.displayedScore.me.push(0)
                    this.vue.displayedScore.opponent.push(1)
                }

                if (status == "win") {
                    if (this.vue.scores.me <= 1 && this.vue.scores.opponent <= 1) {
                        this.vue.audio.play('roundWin')
                    }
                } else {
                    if (this.vue.scores.me <= 1 && this.vue.scores.opponent <= 1) {
                        this.vue.audio.play('roundLoose')
                    }
                }


                if (this.vue.scores.me > 1 || this.vue.scores.opponent > 1) {
                        this.vue.showFinalScore()
                        this.endCombat()
                } else {
                    TweenMax.delayedCall(3, () =>{
                        this.startRound(id + 1)
                        this.vue.audio.setRound(id + 1)
                        this.vue.currentSign = 'none'
                        this.vue.setMove('none')
                        if(id > 0) {
                            TweenMax.delayedCall(0.5, () => {this.vue.audio.play('levelUp')})
                        }
                    })
                }
            }
        })

    }


    checkSign() {
        this.vue.beforePlay = false
        // this.vue.showSigns = true
        // this.vue.activeSignOpp = this.vue.currentSignOpponent
        // this.vue.activeSignMe = this.vue.currentSign
        // setTimeout(() => {
        //     this.vue.showSigns = false
        //     TweenMax.delayedCall(0.5, () => {
        //         this.vue.result = ''
        //     })
        // }, 2500)
        if (this.vue.currentSign === this.vue.currentSignOpponent) {
            this.vue.promptMessage("It's a tie !")

            // setTimeout(() => {
            //     this.vue.promptMessage("")
            // }, 1000)
            return "tie"
        }

        if (this.vue.currentSign == "none") {
            this.vue.promptMessage("We didn't understand,\n try again !")
            this.misSign++
            if(this.misSign === 2){
                this.vue.askButton = true
            }
            return "tie"
        } else if (this.vue.currentSignOpponent == "none") {
            this.vue.promptMessage("We didn't understand your opponent sign,\n try again !")
            return "tie"
        } else if (
            this.vue.currentSign == "paper" && this.vue.currentSignOpponent == "rock" ||
            this.vue.currentSign == "rock" && this.vue.currentSignOpponent == "scissors" ||
            this.vue.currentSign == "scissors" && this.vue.currentSignOpponent == "paper"
        ) {
            // this.vue.promptMessage("You Won !")
            this.glxp.animationManager.blinkHand(1)
            // this.vue.result = 'win'
            return "win"
        } else {
            // this.vue.promptMessage("You lost !")
            this.glxp.animationManager.shakeCam()
            this.glxp.animationManager.blinkHand(0)
            // this.vue.result = 'lose'
            return "lost"
        }



    }

    startAI() {
        WebsocketManager.off("tracking", this.webSocketListener)
        this.ai = new GameAI()
        this.ai.on("tracking", this.webSocketListener = (sign) => {
            this.vue.currentSignOpponent = sign
        })
    }

    restartGame() {
        this.vue.audio.endRounds()
        this.vue.gameEnd = false
        this.currentRound = 0
        this.vue.currentRound = 0
        this.vue.displayedScore.me = []
        this.vue.displayedScore.opponent = []
        WebsocketManager.init()
        this.glxp.animationManager.hideHandRig(1)
        this.glxp.setHandTarget("idle")
        this.glxp.setHandTarget("idle", 1)
        TweenMax.delayedCall(0.5, () => {
            this.glxp.animationManager.hidePlateform()
        })
        TweenMax.delayedCall(3, () => {
            this.glxp.goToStage(0)
        })

        TweenMax.delayedCall(6, () => {
            this.endTuto()
            
            // if(this.buttonMode) this.vue.buttonMode = true
            if(this.buttonMode) this.vue.hideButton = true
        })
    }

    setMode(val) {
        if(val){
            TensorManager.hideFeedBack()
            TensorManager.desactivate()
            // console.log(this.tutoEnded)
            if(this.vue.tutoStep === 0 && !this.tutoEnded){
                this.vue.showTuto = true
                if(!this.vue.skipCam){
                    this.glxp.animationManager.showHandRig(0)
                    this.nextStepTuto()
                }

            }
        } else {
            TensorManager.showFeedBack()
            TensorManager.activate()
        }
        if(!this.tutoEnded){
            if (this.vue.tutoStep == 1) {
                this.buttonMode ? this.vue.promptMessage("Click on rock") : this.vue.promptMessage("Make a rock")
            } else if (this.vue.tutoStep == 2) {
                this.buttonMode ? this.vue.promptMessage("Click on paper") : this.vue.promptMessage("Make a paper")
            } else if (this.vue.tutoStep == 3) {
                this.buttonMode ? this.vue.promptMessage("Click on scissors") : this.vue.promptMessage("Make scissors")
            }
        }

    }

}

export default GameManager
